import moment from 'moment';
import DATE_FORMATS from './DATE_FORMATS';

export default new Array(24).fill(new Date()).map((_, indx) => {
  const time = moment().set({ hour: indx, minute: 0, second: 0, millisecond: 0 });

  return { label: time.format(DATE_FORMATS.ONLY_TIME), value: time.format(DATE_FORMATS.ONLY_24TIME) };
});
